module.exports = __webpack_public_path__ + "img/why-icon-5.68383b53.svg";